import { render } from "./widget-agreement-modal.vue?vue&type=template&id=47035aaa&scoped=true"
import script from "./widget-agreement-modal.vue?vue&type=script&lang=js"
export * from "./widget-agreement-modal.vue?vue&type=script&lang=js"

import "./widget-agreement-modal.vue?vue&type=style&index=0&id=47035aaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47035aaa"]])

export default __exports__